import { render, staticRenderFns } from "./rejectTable.vue?vue&type=template&id=ca7c5c5c&"
import script from "./rejectTable.vue?vue&type=script&lang=js&"
export * from "./rejectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports